import { render, staticRenderFns } from "./tooltip_on_truncate.vue?vue&type=template&id=50568281"
import script from "./tooltip_on_truncate.vue?vue&type=script&lang=js"
export * from "./tooltip_on_truncate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports